import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import PageHero from './Component/PageHero';
import about from './Component/about.png';
import brand1 from './Component/home/brand1.png';
import awards from './Component/awards.png';

function About() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="About us"
        title="About PacifiContract"
        subtitle="Get to know your San Rafael, CA area flooring experts"
      />

      <section className="pb-12 md:pb-20">
        <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:px-8">
          <div className="overflow-hidden rounded-[1.75rem]">
            <img src={about} alt="PacifiContract team" className="h-full w-full object-cover" />
          </div>
          <div className="rounded-[1.75rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/80 sm:p-8 md:p-10">
            <h2 className="text-xl font-semibold tracking-tight sm:text-2xl md:text-3xl">
              Family owned &amp; operated
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base">
              PacifiContract is family owned and operated. We have excellent customer service. We
              specialize in being able to service all of your flooring needs. Hardwood, carpet,
              vinyl sheet and floating floors are our specialty and we are perfectionists. Quality
              work and customer satisfaction is what we strive for. Come in or call and schedule an
              appointment today.
            </p>
            <a
              href="/contact"
              className="mt-6 inline-flex items-center justify-center rounded-full bg-[#0075ca] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad] sm:text-base"
            >
              Contact us
            </a>
          </div>
        </div>
      </section>

      <img src={awards} alt="Awards and recognition" className="mx-auto w-full max-w-6xl px-4 py-4 sm:px-6" />

      <Request />

      <section className="border-t border-slate-200 py-12 md:py-16">
        <div className="mx-auto max-w-6xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="text-xl font-semibold tracking-tight sm:text-2xl md:text-3xl">
            Featured brands &amp; technologies
          </h2>
          <img src={brand1} alt="Featured brands" className="mx-auto mt-8 max-w-full" />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default About;
